import { render } from "./NavIgnite.vue?vue&type=template&id=377abd44&scoped=true"
import script from "./NavIgnite.vue?vue&type=script&lang=js"
export * from "./NavIgnite.vue?vue&type=script&lang=js"

import "./NavIgnite.vue?vue&type=style&index=0&id=377abd44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377abd44"]])

export default __exports__